import { useEffect, useState } from "react";

export function TechnicalHeroOverlay() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    let frame = 0;
    const update = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        const next = reduced.matches ? 0 : Math.min(1, Math.max(0, window.scrollY / Math.max(1, window.innerHeight * 0.9)));
        setProgress(next);
      });
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    reduced.addEventListener("change", update);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      reduced.removeEventListener("change", update);
    };
  }, []);

  const pointOpacity = 0.35 + progress * 0.45;
  const trajectoryOffset = progress * 18;

  return (
    <div className="technical-hero-overlay pointer-events-none absolute inset-0 hidden overflow-hidden lg:block" aria-hidden="true">
      <svg viewBox="0 0 900 620" className="absolute end-[4%] top-[17%] h-[74%] w-[55%] max-w-[58rem] opacity-70" data-hero-overlay="technical">
        <defs>
          <linearGradient id="qm-hero-line" x1="0" x2="1">
            <stop stopColor="#aab5ff" stopOpacity="0.12" />
            <stop offset="0.5" stopColor="#9cbcff" stopOpacity="0.8" />
            <stop offset="1" stopColor="#aab5ff" stopOpacity="0.08" />
          </linearGradient>
          <radialGradient id="qm-hero-glow">
            <stop stopColor="#aab5ff" stopOpacity="0.18" />
            <stop offset="1" stopColor="#aab5ff" stopOpacity="0" />
          </radialGradient>
        </defs>
        <ellipse cx="560" cy="300" rx="290" ry="220" fill="url(#qm-hero-glow)" />
        <g fill="none" stroke="url(#qm-hero-line)">
          <path d="M80 446 C190 344 270 486 392 370 S620 330 820 408" />
          <path d="M48 492 C178 388 274 534 412 416 S646 372 852 452" opacity=".62" />
          <path d="M22 540 C166 430 294 574 426 462 S680 418 878 500" opacity=".35" />
          <path d="M176 156 C304 92 410 174 524 112 S744 82 834 152" opacity=".22" />
        </g>
        <g stroke="#9cbcff" strokeOpacity=".14" strokeWidth="1">
          {Array.from({ length: 9 }, (_, index) => <line key={`v-${index}`} x1={82 + index * 88} y1="70" x2={82 + index * 88} y2="560" />)}
          {Array.from({ length: 6 }, (_, index) => <line key={`h-${index}`} x1="50" y1={110 + index * 82} x2="850" y2={110 + index * 82} />)}
        </g>
        <g fill="#c5d1ff" fillOpacity={pointOpacity}>
          {Array.from({ length: 82 }, (_, index) => {
            const x = 150 + ((index * 79) % 660);
            const y = 190 + ((index * 47) % 268) - Math.sin(index * 0.7) * 17;
            return <circle key={index} cx={x} cy={y} r={index % 8 === 0 ? 2.5 : 1.25} />;
          })}
        </g>
        <g fill="none" stroke="#e9f6f8" strokeWidth="1.4" opacity=".7">
          <path d={`M138 ${418 - trajectoryOffset} C284 ${260 - trajectoryOffset} 386 ${448 - trajectoryOffset} 516 ${300 - trajectoryOffset} S690 ${250 - trajectoryOffset} 800 ${142 - trajectoryOffset}`} strokeDasharray="5 9" />
          <circle cx="516" cy={300 - trajectoryOffset} r="7" />
          <path d={`M516 ${286 - trajectoryOffset}v28M502 ${300 - trajectoryOffset}h28`} />
        </g>
        <g fill="#e9f6f8" opacity=".72">
          <circle cx="738" cy="104" r="3" />
          <circle cx="782" cy="146" r="2" />
          <circle cx="704" cy="166" r="2" />
        </g>
        <g fill="#aab5ff" fontFamily="ui-monospace, monospace" fontSize="10" letterSpacing="1.8" opacity=".72">
          <text x="96" y="96">SURVEY / SPATIAL FRAME</text>
          <text x="550" y="548">X  ·  Y  ·  Z  /  TRAJECTORY</text>
        </g>
      </svg>
      <div className="absolute bottom-[18%] end-[8%] border-s border-t border-cyan-100/25 px-4 py-3 font-mono text-[0.6rem] uppercase tracking-[0.15em] text-cyan-100/65">physical → measured → modeled</div>
    </div>
  );
}
